export function CurrencyFormatter(total: number) {
  return total.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
